/** 画像サイズに対する比率（0〜1）で表現された矩形 */
export type NormalizedRect = {
  x: number
  y: number
  width: number
  height: number
}

export const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max)

/**
 * 矩形を画像の内側（0〜1）に収める。
 *
 * 検査箇所・位置補正基準の座標はいずれも 0〜1 の比率で保持しており、
 * この範囲を外れた値はAPIに拒否される。ポインタ操作は画像の外にも出られるため、
 * APIへ渡す値を組み立てる箇所では必ずこれを通す。
 */
export const clampRect = <T extends NormalizedRect>(rect: T): T => {
  const width = clamp(rect.width, 0, 1)
  const height = clamp(rect.height, 0, 1)

  return {
    ...rect,
    x: clamp(rect.x, 0, 1 - width),
    y: clamp(rect.y, 0, 1 - height),
    width,
    height,
  }
}
